import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=2ca944d5&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca944d5')) {
      api.createRecord('2ca944d5', component.options)
    } else {
      api.reload('2ca944d5', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=2ca944d5&", function () {
      api.rerender('2ca944d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2r1wU4hEhwa13/JS/offershelp.vue"
export default component.exports